import { render, staticRenderFns } from "./AssignStaffModal.vue?vue&type=template&id=f6a2c8cc&"
import script from "./AssignStaffModal.vue?vue&type=script&lang=js&"
export * from "./AssignStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports